<script setup lang="ts">
import { logosMediaSrc, logoAltText, logoDark, logoLight} from '~/io'
const router = useRouter()

const props = withDefaults(defineProps<{
  disableFixed?: boolean
  disableMini?: boolean
}>(), {
  disableFixed: false,
  disableMini: false
})

const { $io } = useNuxtApp()
const fixed = computed(() => !props.disableFixed ? $io.headerFixed : false)
const mini = computed(() => !props.disableMini ? $io.headerFixedMini : false)

</script>

<template>
  <Section class="sec-header-branding relative" :class="[{ 'header-fixed': fixed }, { 'header-fixed-mini': mini }]" w="w-full h-full ">
    <button class="sec-logo" @click="router.push('/')">
      <template v-if="logosMediaSrc === 'file'">
        <div v-if="fixed" key="light" class="logo light">
          <img :src="logoLight" :alt="logoAltText">
        </div>
        <div v-else key="dark" class="logo dark">
          <img :src="logoDark" :alt="logoAltText">
        </div>
      </template>
      <template v-else-if="logosMediaSrc === 'component'">
        <div v-if="fixed" key="light" class="logo light">
          <img :src="logoLight">
        </div>
        <div v-else key="dark" class="logo dark">
          <img :src="logoDark">
        </div>
      </template>
    </button>
  </Section>
</template>

<style lang="scss" scoped>
.sec-header-branding {

height: 100%;
display: flex;
align-items: center;

* {
  transition: all 0.5s ease;
}

:deep(>.m-wrap) {
  display: flex;
  align-items: center;

  position: relative;
}

button.sec-logo {

  position: absolute;
  width: 100%;
  height: 75px;

  cursor: pointer;

 

  border: 0;
  background: transparent;

  transform: translateY(20px);

  @include mq($until: t) {
    height: 60px;
    transform: translateY(10px);
  }

  >.logo {
    width: 100%;
    height: 100%;

    position: relative;
    display:flex;
    justify-content: flex-start;
    img {
      // width: 100%;
      height:100%;
    }
  }

  // &:hover {
  //   transform: translateY(-1px);

  //   &:active {
  //     transform: translateY(0px);
  //   }
  // }
}

&.header-fixed {
  .sec-logo {
    width: 250px;
    height: 50px;

    transform: translateY(0px);
   
    >.logo {
      
    }
  }
}
}
</style>